import React from "react"

export default function CopyIcon({ className }) {
    return <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="5" y="5" width="9" height="9" stroke="black" />
        <path d="M2 12V2H11.75" stroke="black" />
    </svg>

}